import { List, ListDisplayType, Tile } from "@blacknut/javascript-sdk/dist";
import { logD, logE } from "@blacknut/logging/dist";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToFavorite, removeFromFavorite } from "../redux/actions/Game";
import { State } from "../redux/reducers";
import { RouteNames, WithRouterProps } from "../utils/WithRouter";

const TAG = "TileContainer";

export const useTile = (
  props: { item: Tile; list: List; previewMode?: boolean } & WithRouterProps<unknown>,
) => {
  const { item, list, previewMode = false } = props;

  const gameId = item.game?.id;
  const link = item.link?.url;
  const gameState = useSelector((state: State) => state.gamesState.games[gameId || ""]);
  const dispatch = useDispatch();

  return {
    onClick: useCallback(() => {
      if (previewMode) {
        logD(TAG, "tile clicked in preview mode");
        return;
      }
      if (item.game) {
        props.navigate({ name: RouteNames.GAME, gameId: item.game.id });
      }
      if (link) {
        if (link?.startsWith("blacknut://")) {
          props.navigate(link.replace("blacknut://", "/"));
        } else if (link.startsWith("http")) {
          window.open(link, "_self");
        } else {
          props.navigate(link);
        }
      }
      if (item.page) {
        props.navigate({ name: RouteNames.PAGE, pageId: item.page.uuid });
      }
      if (item.marketing) {
        props.navigate({ name: RouteNames.LEMAG, pageId: item.marketing.uuid });
      }
      if (item.lemag) {
        props.navigate({ name: RouteNames.LEMAG, pageId: item.lemag.uuid });
      }
    }, [item.game, previewMode, props]),

    toggleFavorite: useCallback(async () => {
      if (!gameState || !gameState.favoritePending || !gameState?.game) {
        return;
      }
      if (gameState?.favorite) {
        try {
          await removeFromFavorite(gameState?.game)(dispatch);
        } catch (e) {
          logE(TAG, "Caught error toggling favorite", e);
        }
      } else {
        try {
          await addToFavorite(gameState?.game)(dispatch);
        } catch (e) {
          logE(TAG, "Caught error toggling favorite", e);
        }
      }
    }, [dispatch, gameState]),

    onPlayClicked: useCallback(() => {
      if (previewMode) {
        logD(TAG, "play tile clicked in preview mode");
        return;
      }
      if (item.game) {
        props.navigate({
          name: RouteNames.PLAY,
          gameId: item.game.id,
          origin: list.display === ListDisplayType.HERO ? "hero" : "tile",
        });
      }
    }, [item.game, list.display, previewMode, props]),
  };
};
